import { Switch, Text, VStack } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormField } from '../../../components/FormField'
import { FormModal } from '../../../components/FormModal'
import { useAppToast } from '../../../helpers'
import { JobRequisitionService } from '../../../services/JobRequisition/JobRequisitionService'
import { JobRequisition } from '../../../services/JobRequisition/types'
import { AreasField } from './JobRequisitionParts'

interface IJobRequisitionSiteModalProps {
  isOpen: boolean
  onClose: () => void
  onSaved: () => void
  requisition: JobRequisition | null
}

/** A signed RP keeps what was signed; only what the site shows can still change. */
export function JobRequisitionSiteModal({ isOpen, onClose, onSaved, requisition }: IJobRequisitionSiteModalProps) {
  const toast = useAppToast()
  const [areas, setAreas] = useState<string[]>([])
  const [allowPortfolio, setAllowPortfolio] = useState(false)
  const [saving, setSaving] = useState(false)
  const [errors, setErrors] = useState<Record<string, string[]>>({})

  useEffect(() => {
    if (!isOpen || !requisition) return
    setAreas(requisition.areas ?? [])
    setAllowPortfolio(requisition.allow_portfolio_link)
    setErrors({})
  }, [isOpen, requisition?.id])

  const handleSave = () => {
    if (!requisition) return

    setSaving(true)
    new JobRequisitionService()
      .updateSite(requisition.id, { areas, allow_portfolio_link: allowPortfolio })
      .then(() => {
        toast.success(`RP ${requisition.number} atualizada`)
        onSaved()
        onClose()
      })
      .catch((error) => {
        const { status, data } = error?.response ?? {}
        if ((status === 400 || status === 422) && data?.errors) {
          setErrors(data.errors)
          toast.invalidForm()
          return
        }
        toast.error('Erro ao salvar a RP', error)
      })
      .finally(() => setSaving(false))
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Editar RP ${requisition?.number ?? ''}`}
      onSubmit={handleSave}
      isLoading={saving}
    >
      <VStack align="stretch" spacing={5}>
        <Text variant="caption">
          A RP já foi assinada: só as áreas e o envio de portfólio, que aparecem no site, podem mudar.
        </Text>
        <AreasField
          value={areas}
          onChange={(names) => {
            setAreas(names)
            setErrors({})
          }}
          error={errors.areas}
          isDisabled={saving}
        />
        <FormField label="Permitir envio de Portfólio" error={errors.allow_portfolio_link}>
          <Switch
            isChecked={allowPortfolio}
            onChange={(e) => setAllowPortfolio(e.target.checked)}
            isDisabled={saving}
          />
        </FormField>
      </VStack>
    </FormModal>
  )
}
